/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getOperationTheatres } from 'app/entities/operation-theatre/operation-theatre.reducer';
import { getEntities as getEquipmentIPS } from 'app/entities/equipment-ip/equipment-ip.reducer';
import { createEntity, getEntity, reset, updateEntity } from './operation-theatre-equipment.reducer';

export const OperationTheatreEquipmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const operationTheatres = useAppSelector(state => state.operationTheatre.entities);
  const equipmentIPS = useAppSelector(state => state.equipmentIP.entities);
  const operationTheatreEquipmentEntity = useAppSelector(state => state.operationTheatreEquipment.entity);
  const loading = useAppSelector(state => state.operationTheatreEquipment.loading);
  const updating = useAppSelector(state => state.operationTheatreEquipment.updating);
  const updateSuccess = useAppSelector(state => state.operationTheatreEquipment.updateSuccess);

  const handleClose = () => {
    navigate(`/operation-theatre-equipment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getOperationTheatres({}));
    dispatch(getEquipmentIPS({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...operationTheatreEquipmentEntity,
      ...values,
      theatre: operationTheatres.find(it => it.id.toString() === values.theatre?.toString()),
      equipment: equipmentIPS.find(it => it.id.toString() === values.equipment?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...operationTheatreEquipmentEntity,
          theatre: operationTheatreEquipmentEntity?.theatre?.id,
          equipment: operationTheatreEquipmentEntity?.equipment?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.operationTheatreEquipment.home.createOrEditLabel" data-cy="OperationTheatreEquipmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.operationTheatreEquipment.home.createOrEditLabel">
              Create or edit a OperationTheatreEquipment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="operation-theatre-equipment-id"
                  label={translate('tinyMedicRestApp.operationTheatreEquipment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatreEquipment.active')}
                id="operation-theatre-equipment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatreEquipment.lastUpdated')}
                id="operation-theatre-equipment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatreEquipment.timestampEntry')}
                id="operation-theatre-equipment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatreEquipment.microSec')}
                id="operation-theatre-equipment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.operationTheatreEquipment.cursor')}
                id="operation-theatre-equipment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="operation-theatre-equipment-theatre"
                name="theatre"
                data-cy="theatre"
                label={translate('tinyMedicRestApp.operationTheatreEquipment.theatre')}
                type="select"
              >
                <option value="" key="0" />
                {operationTheatres
                  ? operationTheatres.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="operation-theatre-equipment-equipment"
                name="equipment"
                data-cy="equipment"
                label={translate('tinyMedicRestApp.operationTheatreEquipment.equipment')}
                type="select"
              >
                <option value="" key="0" />
                {equipmentIPS
                  ? equipmentIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/operation-theatre-equipment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OperationTheatreEquipmentUpdate;
